var map = {
	"./en/bot.json": [
		"/PTq",
		0
	],
	"./en/card.json": [
		"yl3x",
		0
	],
	"./en/redirect.json": [
		"BsNW",
		0
	],
	"./ru/bot.json": [
		"Sn5o",
		1
	],
	"./ru/card.json": [
		"SYKl",
		1
	],
	"./ru/redirect.json": [
		"unWC",
		1
	],
	"./uk/bot.json": [
		"dnOR",
		2
	],
	"./uk/card.json": [
		"LjwJ",
		2
	],
	"./uk/redirect.json": [
		"xRa8",
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "xhNR";
module.exports = webpackAsyncContext;